'use strict';;
(function ($, window, document) {

	// ----------------------------------- Start : Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws;

	// 取得Window設定值
	var windowSetting = function () {
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();

	// 取得裝置判斷
	// isMobile 判斷
	var isMobile = false;
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true
	}

	var isPhone = ww <= 639;
	var isTable = ww <= 1023;
	// ----------------------------------- End : Setting




	// ------------------------------------------ Start: Swiper breakpoint Detected

	// keep track of swiper instances to destroy later
	var mySwiperItem2 = undefined;

	// ----------------------
	// Swiper breakpoint Detected
	var breakpoint_medium = window.matchMedia('(min-width:1024px)');

	var breakpointChecker_medium = function () {
		// if larger viewport and multi-row layout needed
		if (breakpoint_medium.matches === true) {
			// clean up old instances and inline styles when available
			if (mySwiperItem2 !== undefined) mySwiperItem2.destroy(true, true);

			return;
		} else if (breakpoint_medium.matches === false) {
			return enableSwiper_medium();
		}
	};

	// Add Swiper buildHandler
	var enableSwiper_medium = function () {
		buildSwiperItem2();
	};

	// keep an eye on viewport size changes
	breakpoint_medium.addListener(breakpointChecker_medium);

	// start
	registerListener('load', breakpointChecker_medium);


	// -------------------------------------------
	// Capability List
	// Swiper Setting
	function buildSwiperItem2() {
		var SwiperItem2 = '#capabilities-preface-slider';
		var SwiperItem2BtnNext = $(SwiperItem2).children('.swiper-button-next');
		var SwiperItem2BtnPrev = $(SwiperItem2).children('.swiper-button-prev');

		if ($(SwiperItem2).length <= 0) return false;

		mySwiperItem2 = new Swiper(SwiperItem2, {
			speed: 400,
			// loop: true,
			autoHeight: true,
			spaceBetween: 100,
			slidesPerView: 'auto',
			centeredSlides: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: SwiperItem2BtnNext,
				prevEl: SwiperItem2BtnPrev,
			},
			breakpoints: {
				639: {
					spaceBetween: 30
				},
			}
		});
	};


	// ------------------------------------------- Start : In-House Lab
	// In-House Lab
	// https://codepen.io/Grawl/pen/ZrBEpG
	var SwiperItem3_galleryTop = undefined;
	var SwiperItem3_galleryThumbs = undefined;
	var SwiperItem3_galleryThumbs_old;
	var thumb_isActiveClass = "is-active";

	function buildSwiperItem3() {
		var SwiperItem3 = '#capabilities-thumbs-gallery';
		var SwiperItem3BtnNext = $(SwiperItem3).children('.swiper-button-next');
		var SwiperItem3BtnPrev = $(SwiperItem3).children('.swiper-button-prev');

		var galleryTop = $(SwiperItem3).find('.gallery-top');
		var galleryThumb = $(SwiperItem3).find('.gallery-thumbs');

		if ($(SwiperItem3).length <= 0) return false;

		// 大圖
		SwiperItem3_galleryTop = new Swiper(galleryTop, {
			speed: 400,
			// autoHeight: true,
			spaceBetween: 30,
			lazy: true,
			navigation: {
				nextEl: SwiperItem3BtnNext,
				prevEl: SwiperItem3BtnPrev,
			},
			breakpoints: {
				1023: {
					autoHeight: true
				},
			},
			on: {
				init: function () {
					// Lazy Load Height Bug: https://github.com/nolimits4web/swiper/issues/2509#issuecomment-371506265
					var swiper = this;
					setTimeout(function () {
						swiper.updateAutoHeight();
					}, 200);
				},
				slideChange: function () {
					setCurrentSlide(this.realIndex);
				},
				lazyImageReady: function () {
					var swiper = this;
					setTimeout(function () {
						swiper.updateAutoHeight();
					}, 200);
					console.log(this)
				}
			}
		});

		// 小圖
		SwiperItem3_galleryThumbs = new Swiper(galleryThumb, {
			direction: 'vertical',
			slidesPerView: 3,
			slideToClickedSlide: true,
			spaceBetween: 20,
			lazy: {
				loadPrevNext: true,
			},
			on: {
				init: function () {
					SwiperItem3_galleryThumbs_old = this.slides[this.activeIndex];
					if (SwiperItem3_galleryThumbs_old != undefined) {
						SwiperItem3_galleryThumbs_old.classList.add(thumb_isActiveClass);
					}
				},
				click: qualifyThumbClick,
			}
		});
	};

	function setCurrentSlide(index) {
		if (SwiperItem3_galleryThumbs != undefined) {
			SwiperItem3_galleryTop.slideTo(index);
			SwiperItem3_galleryThumbs.slideTo(index);

			if (SwiperItem3_galleryThumbs_old != undefined) {
				SwiperItem3_galleryThumbs_old.classList.remove(thumb_isActiveClass);
				SwiperItem3_galleryThumbs.slides[index].classList.add(thumb_isActiveClass);
				SwiperItem3_galleryThumbs_old = SwiperItem3_galleryThumbs.slides[index];
			}
		}
	};

	function qualifyThumbClick() {
		if (this.clickedIndex != undefined) {
			setCurrentSlide(this.clickedIndex)
		}
	};

	// After Window Load
	registerListener('load', buildSwiperItem3);

	// ------------------------------------------- End : In-House Lab



})(jQuery, window, document);